import { useMemo } from 'react'

import { EUROPEAN_DATE } from '../../../utils/constants'
import { getTimezoneLessMoment } from '../../../utils/momentjs'
import EllipsedList from './EllipsedList'

const PeriodsEllipsedList = ({ data, maxDisplay }) => {
  const periods = useMemo(() => data.map(({ id, startDate, endDate }) => ({
    id,
    content: `${getTimezoneLessMoment(startDate).format(EUROPEAN_DATE)} - ${getTimezoneLessMoment(endDate).format(EUROPEAN_DATE)}`
  })), [data])

  return (
    <EllipsedList data={periods} maxDisplay={maxDisplay} />
  )
}

export default PeriodsEllipsedList
